const s = {
  name: "UserHeart",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10,8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4.4-3.6,8-8,8S10,12.4,10,8z M18,2c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6
			S21.3,2,18,2z"/>
		<path class="st0" d="M0,29c0-6.1,4.9-11,11-11h14c6.1,0,11,4.9,11,11v11h-2V29c0-5-4-9-9-9H11c-5,0-9,4-9,9v11H0V29z"/>
		<path class="st0" d="M18,26.4c-0.8-0.9-1.9-1.4-3.2-1.4c-2.2,0.1-3.8,2.1-3.8,4.2c0,3.9,2.5,7.4,6.2,8.6l0.8,0.3l0.8-0.3
			c3.7-1.2,6.2-4.7,6.2-8.6c0-2.1-1.6-4-3.8-4.2l0,0C19.9,24.9,18.8,25.5,18,26.4z M14.9,27c1.2-0.1,2.1,0.9,2.1,2h2
			c0-1.1,1-2.1,2.1-2c1,0.1,1.9,1,1.9,2.2c0,3-2,5.8-4.8,6.7L18,35.9l-0.1-0.1l0,0c-2.9-1-4.8-3.7-4.8-6.7C13,28,13.9,27,14.9,27
			L14.9,27z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as UserHeart
};
